import { doDefaultFetch, doDefaultFetchWithBody, CONTENT_TYPES } from '@nhl/fetch-helpers';
import { constants, stringFormatter } from '@nhl/formatter-utilities';

const fetchNews = args => {
    if (args.types) {
        return fetchNewsByType(args);
    } else if (args.ids.length !== 0) {
        return fetchNewsById(args);
    }
};

const fetchNewsById = args => {
    return doDefaultFetch(
        `/site/api/news` +
        (args.isPublic ? '/public' : '') +
        `?start=${args.start}` +
        `&limit=${args.limit}` +
        `&include=contents` +
        `&include=author` +
        `&include=organization` +
        `&include=type` +
        `&include=section` +
        `&include=mediaNews` +
        `&include=mediaNews.attachments` +
        `&cayenneExp=id=${args.ids.reduce((acc, id) =>  acc + ',' + id, args.ids.shift())}`,
        args
    );
};

const fetchNewsByType = args => {
    let fetchUrl =
        `/site/api/news` +
        (args.isPublic ? '/public' : '') +
        `?start=${args.start}` +
        `&limit=${args.limit}` +
        `&include=type` +
        `&include=contents` +
        `&include=author` +
        `&include=organization` +
        `&include=mediaNews` +
        `&include=mediaNews.attachments` +
        `&include=section` +
        '&cayenneExp=["type.name in (' +
        args.types.reduce((acc, type) => {
            if (acc) {
                return acc + ',\'' + type + '\'';
            }
            return '\'' + type + '\'';
        }, false) + ')';

    if (args.fromDate) {
        fetchUrl += ` and publishDate <= '${args.fromDate.format(constants.SQL_DATE_FORMAT)}'`;
    }

    if (args.section) {
        fetchUrl += ` and section.name = '${args.section}'`
    }

    fetchUrl += '"])';

    return doDefaultFetch(fetchUrl, args);
};

const addNewsTypeSlugs = items => items.map(item => {
    const slugProp = {
        slug: encodeURI(stringFormatter.toSlug(item.type.name))
    };
    return Object.assign(item, slugProp);
});

const searchNews = async (requests) => {
    requests.forEach(request => {
        request.params.facets.length === 0 && delete request.params.facets;
        !request.params.tagFilters && delete request.params.tagFilters;
    });

    return await doDefaultFetchWithBody('/site/api/search', {
        contentType: CONTENT_TYPES.JSON,
        body: JSON.stringify({ requests })
    });
};

export default {
    fetchNews,
    fetchNewsById,
    fetchNewsByType,
    addNewsTypeSlugs,
    searchNews
};
